export default "__VITE_ASSET__CKKZr7Ka__"